import React, { useEffect, useState } from 'react';
import { Form, ListGroup, Button, Offcanvas, Toast } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faBars } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import { getCookie } from '../auth/login/GetCookie';

const CategoriesFilter = ({ setSearchResults, params, setIsLoading }) => {
    const [isAerospaceOpen, setIsAerospaceOpen] = useState(true);
    const [isAircraftSubOpen, setIsAircraftSubOpen] = useState(true);
    const [showFilter, setShowFilter] = useState(false);
    const [selectedCategories, setSelectedCategories] = useState(
        params.productCategoryNames ? params.productCategoryNames.split(',') : []
    );
    const [showToast, setShowToast] = useState(false); // Control the visibility of the toast
    const [errorMessage, setErrorMessage] = useState(''); // Store the error message
    const [categories, setCategories] = useState([]);
    // Toggle main category visibility
    const toggleAerospace = () => {
        setIsAerospaceOpen(!isAerospaceOpen);
    };
    useEffect(() => {
        fetchCategories();
      }, []);



  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/category`);
      console.log(response.data)
      
      setCategories(response.data.map(category => category.categoryName)); 
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };
    // Toggle subcategory visibility
    const toggleAircraftSub = () => {
        setIsAircraftSubOpen(!isAircraftSubOpen);
    };

    const toggleFilter = () => {
        setShowFilter(!showFilter);
    };

    const handleCategorySelect = async (category, isChecked) => {
        setIsLoading(true)
        let updatedCategories = [...selectedCategories];

        
    
        if (isChecked) {
            if (!updatedCategories.includes(category)) {
                updatedCategories.push(category); // Add category if it's not already there
                
            }
        } else {
            updatedCategories = updatedCategories.filter((cat) => cat !== category); // Remove category
            
        }
    
        setSelectedCategories(updatedCategories);
    
        // Prepare API query params
        const queryParams = {
            ...params,
            productCategoryNames: updatedCategories.join(','), // Convert array back to a comma-separated string
        };
    
        try {
            // const token = localStorage.getItem("token");
            const token = getCookie("token");

                const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/user/products/search`,
                {
                    headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    },
                    params, // Passing params directly
                }
                );
            setSearchResults(response.data.content);
            setIsLoading(false)
        } catch (error) {
            console.error(`Error fetching products for categories "${category}":`, error);
            setErrorMessage(`Failed to fetch products for category "${category}". Please try again.`);
            setShowToast(true);
            
            setSearchResults([]); // Clear results on failure
        }
    };
    
    return (
        <div>
            {/* Mobile View */}
            <Button variant="light" onClick={toggleFilter} className="d-lg-none">
                <FontAwesomeIcon icon={faBars} />
            </Button>
            <Offcanvas show={showFilter} onHide={toggleFilter} className="col-2" style={{ marginTop: '115px' }}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>All Categories</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <ListGroup>
                        {categories.map((category) => (
                            <ListGroup.Item key={category}>
                                <Form.Check
                                        type="checkbox"
                                        label={category}
                                        checked={selectedCategories.includes(category)} // Ensures checkboxes reflect the selected state
                                        onChange={(e) => handleCategorySelect(category, e.target.checked)}
                                        
                                    />

                            </ListGroup.Item>
                        ))}
                    </ListGroup>
                </Offcanvas.Body>
            </Offcanvas>

            {/* Desktop View */}
            <div className="d-none d-lg-block">
                <h4 style={{color:"#606060"}}>All Categories:</h4>
                <div className="mt-p">
                    <ListGroup>
                        {[
                            'Aerospace',
                            'Land',
                            'Sea',
                            'Unmanned Warfare',
                            'Accessories',
                            'Ammunitions',
                            'Unmanned Aerial Vehicles',
                        ].map((category) => (
                            <ListGroup.Item
                                key={category}
                                style={{
                                    cursor: "pointer",
                                    backgroundColor: selectedCategories.includes(category) ? "#f8f9fa" : "white",
                                    transition: "background-color 0.2s ease-in-out",
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#e9ecef"}
                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = selectedCategories.includes(category) ? "#f8f9fa" : "white"}
                                onClick={() => handleCategorySelect(category, !selectedCategories.includes(category))}
                                        >
                                {/* <Form.Check
                                    type="checkbox"
                                    label={category}
                                    checked={selectedCategories.includes(category)}
                                    onChange={(e) => handleCategorySelect(category, e.target.checked)}
                                /> */}
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
  <input
    type="checkbox"
    checked={selectedCategories.includes(category)}
    onChange={(e) => handleCategorySelect(category, e.target.checked)}
    style={{
      accentColor: '#401201', // 🔥 Try orange or any hex color
      width: '18px',
      height: '18px',
      cursor: 'pointer',
    }}
  />
  <label style={{ fontWeight: '500', cursor: 'pointer' }}>{category}</label>
</div>
                            </ListGroup.Item>
                        ))}
                    </ListGroup>
                </div>
            </div>

            {/* Error Toast */}
            <Toast
    show={showToast}
    onClose={() => setShowToast(false)} // Hide toast on close
    style={{
        backgroundColor: 'white',
        position: 'fixed',
        top: '40%', // Slightly above the center
        left: '50%',
        transform: 'translate(-50%, -40%)', // Center horizontally and vertically offset slightly upward
        zIndex: 1050,
        minWidth: '300px', // Optional: Set a minimum width for better appearance
    }}
>
    <Toast.Header closeButton>
        <strong className="me-auto">Error</strong>
    </Toast.Header>
    <Toast.Body>
        <p>{errorMessage}</p>
        <Button
            variant="primary"
            onClick={() => setShowToast(false)} // Hide toast on Okay click
            className="mt-2"
        >
            Okay
        </Button>
    </Toast.Body>
</Toast>

        </div>
    );
};

export default CategoriesFilter;
